export default "__VITE_ASSET__oo7eEvfo__"